import DownloadModal from './DownloadModal/DownloadModal';

export default DownloadModal;
